import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { Activate, Deactivate } from '../../../interface/Clickable.js';
import Switchable from '../../../interface/Switchable.js';
import LIST, { Collapse, Expand } from '../../DOM/LIST/LIST.js';
import { li } from '../../DOM/LIST/li/LI.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const consoleAttr = makeAttrStruct();
export const consoleData = makeDataStruct();
export const consoleModel = makeStruct();
// Simplified Model
export function consoleEl() {
    return {
        attributes: consoleAttr(),
        data: consoleData()
    };
}
/** A console like panel (UL) that contains entries as list items (LI) */
export default class CONSOLE extends LIST {
    constructor(node, model) {
        super(node, HTMLELEMENT.UL, model);
        this.addClass('console');
        this.implement(new Switchable(this));
        this.on('activate', () => this.do(new Expand(this)));
        this.on('deactivate', () => this.do(new Collapse(this)));
    }
    /** Adds the given text as a list item to the console (UL) at the top of the list
        @param text Text to be added
        @param toConsole If true, is also logged to console
        @param type ie success, info, warning, danger
        @returns {LI} The console entry
    */
    addEntry(text, toConsole = false, type = 'info') {
        let listitem = this.addLI(li(text));
        this.el.scrollTo({
            top: listitem.el.offsetTop,
            behavior: 'smooth'
        });
        if (toConsole) {
            console.log(text);
        }
        return listitem;
    }
    /** Flushes the contents of this console (this.children is not preserved)
        @see https://www.jstips.co/en/javascript/two-ways-to-empty-an-array/
    */
    flush() {
        //console.log(this.toString() + '.flush()', this.children);
        this.empty();
        this.children.length = 0;
        //console.log(this.toString() + '.flush().done()', this.children);
    }
}
export { Activate, Collapse, Deactivate, EL, Expand };
